<template>
    <div id="admin" class="h-100">
        <div class="container-fluid h-100">
            <div class="row h-100">
                <router-view name="nav"></router-view>
                <main class="col col-md-10">
                    <router-view></router-view>
                </main>
            </div>
        </div>
        <router-view name="footer" v-if="!$wait.any"/>
    </div>
</template>

<script>
  export default {
    name: 'Layout'
  };
</script>

<style scoped>

</style>
